import React from 'react'
import LoginWithEmail from '../user/login'

export default function Login() {
  return (
    <LoginWithEmail />
  )
}
